import { render, staticRenderFns } from "./pcPreview.vue?vue&type=template&id=37dc6d2c&scoped=true&"
import script from "./pcPreview.vue?vue&type=script&lang=js&"
export * from "./pcPreview.vue?vue&type=script&lang=js&"
import style0 from "./pcPreview.vue?vue&type=style&index=0&id=37dc6d2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc6d2c",
  null
  
)

export default component.exports